exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".odemeyap[data-v-40a32068]{margin-bottom:20px;border:1px solid #ebeef5;padding:10px}.odemeyap h5[data-v-40a32068]{font-size:12px;text-align:center;background:#ebeef5;padding:5px}iframe[data-v-40a32068]{width:100%;border:none;height:700px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40a32068","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pack/Genel/Hesap.vue
// module id = 412
// module chunks = 0